import { useMemo } from "react";

import { useGetSignupsList } from "./queries";

const useActiveSignups = () => {
  const { data } = useGetSignupsList();

  return useMemo(
    () =>
      data?.signupLists?.filter((signup) => signup?.signupListStatusID === 1) ||
      [],
    [data?.signupLists]
  );
};

const useHasActiveSignups = () => {
  const activeSignups = useActiveSignups();
  return useMemo(() => activeSignups.length > 0, [activeSignups.length]);
};

export { useActiveSignups, useHasActiveSignups };
